module.exports = __webpack_public_path__ + "media/tuut.32d9b81f.wav";